import _ from "lodash";
// import TopBar from "@/app/[code]/TopBar";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// import MyFarmer from "@/app/[code]/MyFarmer";
// import MySource from "@/app/[code]/MySource";
// import MyJourney from "@/app/[code]/MyJourney";
// import BottomBar from "@/app/[code]/BottomBar";
import Box from "@mui/material/Box";
// import ComingSoon from "@/app/[code]/ComingSoon";
// import CodeNotFound from "@/app/[code]/CodeNotFound";
import { useEffect, useState } from "react";
import KimayeService from "../../Services/KimayeService";
import { useParams } from "react-router-dom";
import TopBar from "./TopBar";
import ComingSoon from "./ComingSoon";
import CodeNotFound from "./CodeNotFound";
import MyFarmer from "./MyFarmer";
import MySource from "./MySource";
import BottomBar from "./BottomBar";
import MyJourney from "./MyJourney";
import BlockUi from "react-block-ui";

const OutputCode = () => {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState("not_started");
  const [sourceDetails, setSourceDetails] = useState(null);
  const [showNotFound, setShowNotFound] = useState(false);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [locationData, setLocationData] = useState(null);
  const [menuItems, setMenuItems] = useState([]);
  const { code } = useParams();

  useEffect(() => {
    setLoading("started");
    const { axiosRequest, abortController } =
      KimayeService.getOutputUiSheetData(code);
    axiosRequest
      .then((response) => {
        if (response?.data?.sourceDetails) {
          let sourceDetails = response?.data?.sourceDetails;

          setSourceDetails(response?.data?.sourceDetails);

          if (sourceDetails) {
            if (
              sourceDetails?.farmerName === "" &&
              sourceDetails?.productCode
            ) {
              setShowComingSoon(true);
            }
          } else if (
            sourceDetails?.farmerName === "" &&
            sourceDetails?.productCode === ""
          ) {
            setShowNotFound(true);
          } else {
            setShowNotFound(true);
          }

          if (!sourceDetails) {
            setShowNotFound(true);
          }

          let menuItemsToPush = [];
          if (sourceDetails?.crop) {
            menuItemsToPush.push({
              name: "Meet My Farmer",
              href: "#my-farmer",
            });
          }
          if (sourceDetails?.location && sourceDetails?.state) {
            setLocationData({
              District: sourceDetails?.location,
              State: sourceDetails?.state,
              Country: sourceDetails?.country,
            });
            menuItemsToPush.push({
              name: "View My Source",
              href: "#my-source",
            });
          }
          if (sourceDetails?.crop) {
            menuItemsToPush.push({
              name: "See My Journey",
              href: "#my-journey",
            });
          }
          setMenuItems(menuItemsToPush);
        } else {
          setShowNotFound(true);
        }
        setLoading("done");
      })
      .catch((error) => {
        if (error?.message !== "canceled") {
          if (error.data) {
            setError(error.data);
            console.log(error.data);
          } else {
            setError(error);
            console.log(error);
          }
          setShowNotFound(true);
          setLoading("done");
        }
      });
  }, [code]);

  return (
    <main style={{ backgroundColor: "#fff" }}>
      <BlockUi
        tag="div"
        keepInView
        message={`Loading...`}
        blocking={loading === "started"}
        style={{ minHeight: `90vh`, marginBottom: "24px" }}
      >
        {loading === "done" && sourceDetails ? (
          <>
            {menuItems.length > 0 ? <TopBar menuItems={menuItems} /> : <></>}

            <Container>
              <>
                {showComingSoon ? (
                  <ComingSoon
                    sequenceNumber={sourceDetails?.sequenceNumber}
                  ></ComingSoon>
                ) : (
                  <></>
                )}

                {showNotFound ? <CodeNotFound></CodeNotFound> : <></>}

                {!showComingSoon && !showNotFound ? (
                  <>
                    <Grid container sx={{ marginTop: 2 }}>
                      <Grid item xs={12}>
                        <Box sx={{ textAlign: "center" }}>
                          <img
                            src={`https://static.agrostar.in/output/output-landing-page.jpg`}
                            alt={`Welcome`}
                            width={320}
                            height={700}
                          />
                        </Box>
                      </Grid>
                    </Grid>
                    {sourceDetails?.crop ? (
                      <MyFarmer farmerData={sourceDetails} />
                    ) : (
                      <></>
                    )}

                    {sourceDetails?.location && sourceDetails?.state ? (
                      <MySource locationData={locationData} />
                    ) : (
                      <></>
                    )}

                    {sourceDetails?.crop ? (
                      <MyJourney cropName={sourceDetails.crop} />
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <></>
                )}
              </>

              <BottomBar />
            </Container>
          </>
        ) : loading === "done" && !sourceDetails ? (
          <CodeNotFound />
        ) : (
          <></>
        )}
      </BlockUi>
    </main>
  );
};

export default OutputCode;
